var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main"
  }, [_c('AppVideo'), _vm._v(" "), _c('section', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row l-wrap l-flex-center l-items-baseline"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      class: ['product l-s', ( _obj = {}, _obj[product.theme] = true, _obj )]
    }, [_c('div', {
      staticClass: "product__image"
    }, [_c('div', {
      staticClass: "item",
      attrs: {
        "data-path-scaleX": "0.7",
        "data-path-scaleY": "0.7",
        "data-path-rotate": "25",
        "data-animation-path-duration": "2000",
        "data-morph-path": ""
      }
    }, [_c('div', {
      staticClass: "absolute-center"
    }, [_c('router-link', {
      staticClass: "product__link",
      attrs: {
        "to": '/product/' + product.slug + '/' + product.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.image + '?w=310&h=410',
        "alt": "Product"
      }
    })]), _vm._v(" "), _c('h2', {
      staticClass: "product__title"
    }, [_c('router-link', {
      staticClass: "product__link",
      attrs: {
        "to": '/product/' + product.slug + '/' + product.id
      }
    }, [_vm._v(_vm._s(product.title))])], 1)], 1), _vm._v(" "), _c('svg', {
      staticClass: "item__svg",
      attrs: {
        "width": "500px",
        "height": "500px",
        "viewBox": "0 0 500 500"
      }
    }, [_c('clipPath', {
      attrs: {
        "id": 'id' + product.id
      }
    }, [_c('path', {
      staticClass: "item__clippath",
      attrs: {
        "d": ""
      }
    })]), _vm._v(" "), _c('g', {
      attrs: {
        "clip-path": 'url(#id' + product.id + ')'
      }
    }, [_c('path', {
      attrs: {
        "d": "M0,0h600v600H0V0z"
      }
    })])])])])])
    var _obj;
  })), _vm._v(" "), _c('div', {
    staticClass: "products__view-all"
  }, [_c('img', {
    staticClass: "bear",
    attrs: {
      "src": "/static/images/bear.png",
      "alt": "Bear"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn--primary",
    attrs: {
      "to": "/products"
    }
  }, [_vm._v("Виж всички Бимби продукти")])], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31c63dcd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = Pj8z
// module chunks = 1